import Image from "next/image";
import Heading from "~/componentsDS/Typography/Heading";
import Paragraph from "~/componentsDS/Typography/Paragraph";

const ComparisonOthersCard = () => (
    <div className="py-[10px] md:py-0">
        <div className="relative pt-8 md:pb-10 h-[500px] md:h-[550px] bg-gray100 rounded-2xl overflow-hidden">
            <div className="relative h-full flex flex-col items-center">
                <Paragraph weight="300" className="hidden md:block text-[26.5px] leading-[1.1] tracking-[-0.01em] text-center text-gray500 mb-6">
                    Most hormone therapy <br />
                    ends up looking like this:
                </Paragraph>
                <Heading size="xs" weight="400" className="mb-6">The Other Methods</Heading>
                <Image
                    src="https://res.cloudinary.com/dirscuuhp/image/upload/v1775408332/new_design/Oestra_Magnific_Precision_Upscale_V2_2026-02-28_19-12-33_1_mfgzfw.webp"
                    alt="Others hormone therapies"
                    width={222}
                    height={231}
                    className="object-cover object-center"
                />
                <Paragraph size="xl" weight="500" className="md:hidden mt-6 text-center">
                    Most hormone therapy ends up <br />looking like this:
                </Paragraph>
                <Paragraph size="md" sizes={{ md: "lg" }} className="text-center text-trueBlack mt-[10px] md:mt-auto">
                    Estrogen patch <br />
                    Progesterone pill <br />
                    Vaginal cream <br />
                    Sometimes testosterone <br /><br />
                    <span className="hidden md:block">But it’s fragmented.</span>
                </Paragraph>
            </div>
        </div>
    </div>
);

export default ComparisonOthersCard;
